<template>
  <div v-if="(customerOrder&&$store.getters.userType == '00')||($store.getters.enterpriseId=='72620e120c3a11ef8a26fa163ec52c23'&&$store.getters.userType == '22')">
    <!-- v-if="enterpriseId=='72620e120c3a11ef8a26fa163ec52c23'" -->
    <a-badge :count="xiadanCount" @click="CustomerOrders">
      <a class="action ant-dropdown-link user-dropdown-menu">
        客户下单
      </a>
    </a-badge>

    <a-modal
      title="客户下单"
      style="top: 20px;"
      v-model="visible12"
      :width="1400"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit12"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <div class="table-page-search-wrapper">
        <a-form :form="form3" layout="inline">
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-input v-model="enterpriseName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户姓名">
                <a-input v-model="customerName" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户联系方式">
                <a-input v-model="customerMobile" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="客户下单时间">
                <a-range-picker
                  v-model="time"
                  style="width:100%;"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChange1"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="客户地址">
                <a-select :allowClear="true" v-decorator="['provinceId']">
                  <a-select-option
                    :title="type.provinceName"
                    :value="type.provinceCode"
                    v-for="type in provinceMap"
                    :key="type.provinceCode"
                    @click="changeProvince(type.provinceCode)"
                    >{{ type.provinceName }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="">
                <a-select :allowClear="true" v-decorator="['cityId']">
                  <a-select-option
                    :title="type.cityName"
                    :value="type.cityCode"
                    v-for="type in cityMap"
                    :key="type.provinceCode"
                    @click="changeCity(type.cityCode)"
                    >{{ type.cityName }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="5">
              <a-form-item label="">
                <a-select :allowClear="true" v-decorator="['areaId']">
                  <a-select-option
                    :title="type.areaName"
                    :value="type.areaCode"
                    v-for="type in areaArr"
                    :key="type.areaCode"
                    @click="changeArea(type.areaCode)"
                    >{{ type.areaName }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="5">
              <a-form-item label="详细地址">
                <a-input v-model="detailedAddress" />
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="安装类别" style="margin-left: 28px">
                <a-select @change="installChange" :allowClear="true" v-model="installType">
                  <a-select-option v-for="type in installTypes" :key="type.code">{{ type.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="订单类型" style="margin-left: 28px">
                <a-select :allowClear="true" @change="orderTypeChange" v-model="orderType">
                  <a-select-option v-for="type in List" :key="type.orderTypeId">{{ type.typeName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 1 || status == 2">
              <a-form-item label="处理人" style="margin-left: 14px">
                <a-input v-model="updateBy"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 1 || status == 2">
              <a-form-item label="处理时间">
                <!--<a-input  v-model="updateTime"></a-input>-->
                <a-range-picker
                  v-model="updateTime"
                  style="width:100%;"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChange2"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 1">
              <a-form-item label="订单号" style="margin-left: 42px">
                <a-input v-model="orderNo" />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 2">
              <a-form-item label="移除人" style="margin-left: 42px">
                <a-input v-model="deleteBy"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 2">
              <a-form-item label="移除时间" style="margin-left: 28px">
                <!--<a-input v-model="deleteTime"></a-input>-->
                <a-range-picker
                  v-model="deleteTime"
                  style="width:100%;"
                  format="YYYY-MM-DD HH:mm:ss"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                  }"
                  @change="onChange3"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
            <a-col :span="6" v-if="status == 2">
              <a-form-item label="移除原因">
                <!--                <a-input v-model="deleteReason"></a-input>-->
                <a-select
                  v-model="deleteReason"
                  showSearch
                  optionFilterProp="children"
                  @change="handleChange"
                  :filterOption="filterOption"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in restaurantOperType" :key="type.code" :value="type.code">
                    {{ type.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" :offset="19" style="text-align: right">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="queryList">查询</a-button>
                
                <a-button style="margin:0 8px" @click="queryKong">清空</a-button>
                <a-button v-if="Except" type="primary" @click="xiadanExcept">导出EXCEL</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-divider></a-divider>
      <a-tabs type="card" @change="changeTabs">
        <a-tab-pane key="1">
          <span slot="tab">
            <span>待处理 </span>
            <span style="color: red"> [{{ datalist12 }}]</span>
          </span>
          <a-table
            :loading="loading2"
            size="default"
            ref="table"
            :pagination="false"
            showHeader="false"
            :data-source="data12"
            :columns="columns12"
            :scroll="{ x: 1600 }"
            bordered
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <span
              v-for="list in columns12"
              v-if="list.dataIndex != 'action'"
              :slot="list.dataIndex"
              slot-scope="text, record"
            >
              <a-popover>
                <template slot="content">
                  <p>
                    <span>客户姓名：</span>
                    <span>{{ record.customerName }}</span>
                  </p>
                  <p>
                    <span>客服电话：</span>
                    <span>{{ record.customerMobile }}</span>
                  </p>
                  <p>
                    <span>客户地址：</span>
                    <span>{{ record.address }}</span>
                  </p>
                  <p>
                    <span>订单类型：</span>
                    <span>{{ record.orderType }}</span>
                  </p>
                  <p>
                    <span>安装类别：</span>
                    <span>{{ record.installType }}</span>
                  </p>
                  <p v-for="item in record.infoList" v-if="item.infoValue != null">
                    <span>{{ item.infoName }}：</span>
                    <span>{{ item.infoValue }}</span>
                  </p>
                </template>
                <span type="primary">
                  {{ text }}
                </span>
              </a-popover>
            </span>
            <span v-else slot="action" slot-scope="text, record">
              <a @click="handleEditInfo(record)" v-if="$store.getters.userType == '22'&&enterpriseId=='72620e120c3a11ef8a26fa163ec52c23'">编辑</a>
              <a-divider type="vertical"  v-if="$store.getters.userType == '22'&&enterpriseId=='72620e120c3a11ef8a26fa163ec52c23'"/>
              <a @click="handleEdit12(record)">下单</a>
              <a-divider type="vertical" />
              <a @click="handleRemove12(record)">移除</a>
            </span>
          </a-table>
          <a-pagination
            show-size-changer
            show-quick-jumper
            :total="total"
            v-model="current"
            :pageSizeOptions="pageSizeOptions"
            :pageSize.sync="pageSize"
            @change="onChangePage"
            @showSizeChange="onShowSizeChange"
            :showTotal="total => `总共 ${total} 条`"
            style="float: right;margin: 30px 10px 10px 0"
          />
        </a-tab-pane>
        <a-tab-pane key="2" tab="已处理">
          <a-table
            size="default"
            :pagination="false"
            ref="table"
            showHeader="false"
            :data-source="data13"
            :columns="columns13"
            :scroll="{ x: 1600 }"
            bordered
          >
            <span
              v-for="list in columns13"
              v-if="list.dataIndex != 'action'"
              :slot="list.dataIndex"
              slot-scope="text, record"
            >
              <a-popover>
                <template slot="content">
                  <p>
                    <span>客户姓名：</span>
                    <span>{{ record.customerName }}</span>
                  </p>
                  <p>
                    <span>客服电话：</span>
                    <span>{{ record.customerMobile }}</span>
                  </p>
                  <p>
                    <span>客户地址：</span>
                    <span>{{ record.address }}</span>
                  </p>
                  <p>
                    <span>订单类型：</span>
                    <span>{{ record.orderType }}</span>
                  </p>
                  <p>
                    <span>安装类别：</span>
                    <span>{{ record.installType }}</span>
                  </p>
                  <p v-for="item in record.infoList" v-if="item.infoValue != null">
                    <span>{{ item.infoName }}：</span>
                    <span>{{ item.infoValue }}</span>
                  </p>
                </template>
                <span type="primary">
                  {{ text }}
                </span>
              </a-popover>
            </span>
          </a-table>
          <a-pagination
            show-size-changer
            show-quick-jumper
            :total="total"
            v-model="current"
            :pageSizeOptions="pageSizeOptions"
            :pageSize.sync="pageSize"
            @change="onChangePage"
            @showSizeChange="onShowSizeChange"
            :showTotal="total => `总共 ${total} 条`"
            style="float: right;margin: 30px 10px 10px 0"
          />
        </a-tab-pane>
        <a-tab-pane key="3" tab="回收站">
          <a-table
            :pagination="false"
            size="default"
            ref="table"
            showHeader="false"
            :data-source="data14"
            :columns="columns14"
            :scroll="{ x: 1600 }"
            bordered
          >
            <span
              v-for="list in columns14"
              v-if="list.dataIndex != 'action'"
              :slot="list.dataIndex"
              slot-scope="text, record"
            >
              <a-popover>
                <template slot="content">
                  <p>
                    <span>客户姓名：</span>
                    <span>{{ record.customerName }}</span>
                  </p>
                  <p>
                    <span>客服电话：</span>
                    <span>{{ record.customerMobile }}</span>
                  </p>
                  <p>
                    <span>客户地址：</span>
                    <span>{{ record.address }}</span>
                  </p>
                  <p>
                    <span>订单类型：</span>
                    <span>{{ record.orderType }}</span>
                  </p>
                  <p>
                    <span>安装类别：</span>
                    <span>{{ record.installType }}</span>
                  </p>
                  <p v-for="item in record.infoList" v-if="item.infoValue != null">
                    <span>{{ item.infoName }}：</span>
                    <span>{{ item.infoValue }}</span>
                  </p>
                </template>
                <span type="primary">
                  {{ text }}
                </span>
              </a-popover>
            </span>
            <span v-else slot="action" slot-scope="text, record">
              <a @click="handleAdd14(record)">恢复</a>
            </span>
          </a-table>
          <a-pagination
            show-size-changer
            show-quick-jumper
            :total="total"
            v-model="current"
            :pageSizeOptions="pageSizeOptions"
            :pageSize.sync="pageSize"
            @change="onChangePage"
            @showSizeChange="onShowSizeChange"
            :showTotal="total => `总共 ${total} 条`"
            style="float: right;margin: 30px 10px 10px 0"
          />
        </a-tab-pane>
        <a-button type="primary" slot="tabBarExtraContent" v-if="status == 0" @click="handleEdit18">
          批量下单
        </a-button>
      </a-tabs>
    </a-modal>
    <!--编辑弹框 :confirmLoading="confirmLoading"-->
    <a-modal
      title="基本信息修改"
      style="top: 20px;"
      v-model="visibleEdit"
      :width="600"
      @ok="handleSubmitEdit"
      :confirmLoading="confirmLoading"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <a-form :form="formEdit" @submit="handleSubmitEdit">
        <a-row :gutter="14">
          <a-col :span="12">
            <a-form-item label="客户姓名">
              <a-input style="width: 100%" v-decorator="['customerName', { rules: [{ required: true, message: '请填写客户姓名' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="联系方式">
              <a-input style="width: 100%" v-decorator="['customerMobile', { rules: [{ required: true, message: '请填写联系方式' }] }]" />
  
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="安装地址(省)">
              <a-select :allowClear="true" v-decorator="['provinceId', { rules: [{ required: true, message: '请选择' }] }]">
                  <a-select-option
                    :title="type.provinceName"
                    :value="type.provinceCode"
                    v-for="type in provinceMap"
                    :key="type.provinceCode"
                    @click="changeProvince(type.provinceCode)"
                    >{{ type.provinceName }}</a-select-option
                  >
                </a-select>
              
            </a-form-item>
          </a-col>
          <a-col :span="8">
              <a-form-item label="(市)">
                <a-select :allowClear="true" v-decorator="['cityId', { rules: [{ required: true, message: '请选择' }] }]">
                  <a-select-option
                    :title="type.cityName"
                    :value="type.cityCode"
                    v-for="type in cityMap"
                    :key="type.provinceCode"
                    @click="changeCity(type.cityCode)"
                    >{{ type.cityName }}</a-select-option
                  >
                </a-select>
              </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="(区)">
              <a-select :allowClear="true" v-decorator="['areaId', { rules: [{ required: true, message: '请选择' }] }]">
                <a-select-option
                  :title="type.areaName"
                  :value="type.areaCode"
                  v-for="type in areaArr"
                  :key="type.areaCode"
                  @click="changeArea(type.areaCode)"
                  >{{ type.areaName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="详细地址">
              <a-input v-decorator="['detailedAddress', { rules: [{ required: true, message: '请填写详细地址' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="订单号">
              <a-input v-decorator="['originalOrderNo', { rules: [{ required: true, message: '请填写订单号' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="安装数量">
              <a-input-number :min="1"
                v-decorator="['number', { rules: [{ required: true, message: '请填写数量!' }] }]"
                style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="安装类型">
              <a-select @change="installChangeEd" :allowClear="true" v-decorator="['installType', { rules: [{ required: true, message: '请选择安装类型' }] }]">
                  <a-select-option v-for="type in installTypeList" :key="type.code">{{ type.name }}</a-select-option>
                </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="订单类型">
              <a-select :allowClear="true" v-decorator="['orderType', { rules: [{ required: true, message: '请选择订单类型' }] }]">
                  <a-select-option v-for="type in ListEd" :key="type.code">{{ type.name }}</a-select-option>
                </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="品牌型号">
              <a-input v-decorator="['model', { rules: [{ required: true, message: '请填写品牌型号' }] }]" />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="序列号">
              <a-input v-decorator="['serialNumber', { rules: [{ required: true, message: '请填写序列号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="购买渠道">
              <a-input v-decorator="['purchaseOfStore', { rules: [{ required: false, message: '请填写购买渠道' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="我的要求">
              <a-input v-decorator="['clientRequire', { rules: [{ required: false, message: '请填写我的要求' }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--客户下单移除弹框-->
    <a-modal
      title="客户下单移除"
      style="top: 20px;"
      v-model="visible13"
      :width="600"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit13"
      :destroyOnClose="true"
    >
      <a-form :form="form" @submit="handleSubmit13">
        <a-form-item label="移除原因" :label-col="formItemLayout1.labelCol" :wrapper-col="formItemLayout1.wrapperCol">
          <a-select
            v-decorator="['status', { initialValue: '', rules: [{ required: true, message: '请选择状态' }] }]"
            @change="removeState"
          >
            <a-select-option v-for="type in restaurantOperType" :key="type.code" :value="type.code">
              {{ type.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="备注" :label-col="formItemLayout1.labelCol" :wrapper-col="formItemLayout1.wrapperCol">
          <a-textarea
            v-if="removeStateNum == 3"
            style="height: 150px"
            v-decorator="['remark', { rules: [{ required: true, message: '请输入备注' }] }]"
          ></a-textarea>
          <a-textarea
            v-else
            v-decorator="['remark', { rules: [{ required: false, message: '请输入备注' }] }]"
            style="height: 150px"
            @change="remarkChange"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { checkPermission } from '@/utils/permissions'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
import { mapState } from 'vuex'
import pick from 'lodash.pick'
import { getselectChannel,editCustomerOrder,selectInstallType,selectOrderType} from '@/api/order/NewlyaddedOrderList'

export default {
  name: 'Holdorder',
  components: {},
  computed: {
    ...mapState(['xiadanCount']) // 客户下单数量
  },
  data() {
    return {
      loading2: false,
      form: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      formEdit: this.$form.createForm(this),
      // 查询购买渠道下拉框
      selectChannel: [],
      installTypeList: [],
      ListEd:[],
      infoEdit:{},
      visibleEdit: false,
      enterpriseId:'',
      total: 0,
      pageSize: 10,
      pageNum: 1,
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      visible12: false,
      visible13: false,
      status: '',
      confirmLoading: false,
      formItemLayout1: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 }
        }
      },
      enterpriseName: '',
      customerName: '',
      customerMobile: '',
      time: '',
      updateTime: '',
      deleteTime: '',
      createStartTime: null,
      createEndTime: null,
      updateStartTime: null,
      updateEndTime: null,
      deleteStartTime: null,
      deleteEndTime: null,
      detailedAddress: '',
      installType: '',
      orderType: '',
      updateBy: '',
      orderNo: '',
      deleteBy: '',
      deleteReason: '',
      installTypes: [],
      List: [],
      data12: [],
      data13: [],
      data14: [],
      provinceMap: [],
      cityMap: [],
      areaArr: [],
      restaurantOperType: [],
      selectedRowKeys: [],
      columns12: [
        {
          title: '序号',
          width: 60,
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: ' 操作',
          width: 60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: ' 锁业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
          scopedSlots: { customRender: 'enterpriseName' }
        },
        {
          title: '客户姓名 ',
          dataIndex: 'customerName',
          align: 'center',
          scopedSlots: { customRender: 'customerName' }
        },
        {
          title: '客户联系方式 ',
          dataIndex: 'customerMobile',
          align: 'center',
          scopedSlots: { customRender: 'customerMobile' }
        },
        {
          title: '客户安装地址 ',
          dataIndex: 'address',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          scopedSlots: { customRender: 'installType' }
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
          scopedSlots: { customRender: 'orderType' }
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
          scopedSlots: { customRender: 'number' }
        },
        {
          title: '客户下单时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        }
      ],
      columns13: [
        {
          title: '序号',
          width: 60,
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: ' 订单号',
          dataIndex: 'orderNo',
          align: 'center',
          scopedSlots: { customRender: 'orderNo' }
        },
        {
          title: ' 锁业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
          scopedSlots: { customRender: 'enterpriseName' }
        },
        {
          title: '客户姓名 ',
          dataIndex: 'customerName',
          align: 'center',
          scopedSlots: { customRender: 'customerName' }
        },
        {
          title: '客户联系方式 ',
          dataIndex: 'customerMobile',
          align: 'center',
          scopedSlots: { customRender: 'customerMobile' }
        },
        {
          title: '客户安装地址 ',
          dataIndex: 'address',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          scopedSlots: { customRender: 'installType' }
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
          scopedSlots: { customRender: 'orderType' }
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
          scopedSlots: { customRender: 'number' }
        },
        {
          title: '客户下单时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '处理时间',
          dataIndex: 'updateTime',
          align: 'center',
          scopedSlots: { customRender: 'updateTime' }
        },
        {
          title: '处理人',
          dataIndex: 'updateBy',
          align: 'center',
          scopedSlots: { customRender: 'updateBy' }
        }
      ],
      columns14: [
        {
          title: '序号',
          width: 60,
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: ' 操作',
          width: 60,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: ' 锁业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
          scopedSlots: { customRender: 'enterpriseName' }
        },
        {
          title: '客户姓名 ',
          dataIndex: 'customerName',
          align: 'center',
          scopedSlots: { customRender: 'customerName' }
        },
        {
          title: '客户联系方式 ',
          dataIndex: 'customerMobile',
          align: 'center',
          scopedSlots: { customRender: 'customerMobile' }
        },
        {
          title: '客户安装地址 ',
          dataIndex: 'address',
          scopedSlots: { customRender: 'address' }
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
          scopedSlots: { customRender: 'installType' }
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
          scopedSlots: { customRender: 'orderType' }
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
          scopedSlots: { customRender: 'number' }
        },
        {
          title: '客户下单时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '处理时间',
          dataIndex: 'updateTime',
          align: 'center',
          scopedSlots: { customRender: 'updateTime' }
        },
        {
          title: '处理人',
          dataIndex: 'updateBy',
          align: 'center',
          scopedSlots: { customRender: 'updateBy' }
        },
        {
          title: '移除时间',
          dataIndex: 'deleteTime',
          align: 'center',
          scopedSlots: { customRender: 'deleteTime' }
        },
        {
          title: '移除人',
          dataIndex: 'deleteBy',
          align: 'center',
          scopedSlots: { customRender: 'deleteBy' }
        },
        {
          title: '移除原因',
          dataIndex: 'deleteReason',
          scopedSlots: { customRender: 'deleteReason' }
        }
      ],
      customerOrder: checkPermission('customerOrder:list'),

      Except: checkPermission('customer:order:export') //导出
      //
    }
  },
  async created() {
    console.log(this.Except)
    this.selectChannel = []
    this.enterpriseId = this.$store.getters.enterpriseId
    // 查询信息来源下拉框
    await getselectChannel().then((res) => {
      if (res.code === 0) {
        this.selectChannel = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    // await selectInstallType({enterpriseId:this.enterpriseId}).then(res=>{
    //   this.installTypeList=res.rows
    // })
    
    this.axios({
      url: '/system/dict/data/type',
      method: 'get',
      params: { dictType: 'install_type' }
    }).then(res => {
      const map = new Map()
      // console.log(res)
      res.map(d => {
        map.set(d.dictValue, d.dictLabel)
      })
      // console.log(map)
      this.restaurantOperTypeMap = map
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.installTypes.push({ code: key, label: value })
        // console.log(this.installTypes)
      })
    })
    this.axios({
      url: '/system/dict/data/type',
      method: 'get',
      params: { dictType: 'remove_type' }
    }).then(res => {
      const map = new Map()
      // console.log(res)
      res.map(d => {
        map.set(d.dictValue, d.dictLabel)
      })
      // console.log(map)
      this.restaurantOperTypeMap2 = map
      this.restaurantOperTypeMap2.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantOperType.push({ code: key, label: value })
        // console.log(this.restaurantOperType)
      })
    })
    //获取省
    this.$axios({
      url: '/api/basicdata/province/selectAllProvince',
      method: 'post',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      // console.log(res.data.rows)
      if (res.data.code == 0) {
        this.provinceMap = res.data.rows
      }
    })
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    //分页
    onChangePage(page, pageNumber) {
      // this.current = page
      // console.log(page,pageNumber)
      this.pageNum = page
      this.queryList()
    },

    onShowSizeChange(current, pageSize) {
      // console.log(current, pageSize)
      this.pageSize = pageSize
      this.pageNum = current
      this.queryList()
    },
    moment,
    // 客户下单
    CustomerOrders() {
      this.visible12 = true
      this.status = (this.$store.getters.userType == '22'&&this.$store.getters.enterpriseId=='72620e120c3a11ef8a26fa163ec52c23')?3:0
      this.queryKong()
      ;(this.selectedRowKeys = []),
        this.$axios({
          method: 'get',
          url: '/api/order/customer/selectOrderList',
          params: {
            enterpriseId: '',
            customerName: '',
            customerMobile: '',
            provinceId: '',
            cityId: '',
            areaId: '',
            detailedAddress: '',
            installType: '',
            orderType: '',
            createTime: '',
            status: this.status,
            pageSize: 10,
            pageNum: 1
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res.data)
          this.data12 = res.data.rows
          this.total = res.data.total
          this.datalist12 = res.data.rows.length

        })
    },
    installChangeEd(e) {
      this.ListEd = []
      selectOrderType({enterpriseId:this.enterpriseId,installType:e}).then(res => {
        this.ListEd=res.data
      })
    },
    // 时间
    onChange1(value, dateString) {
      // console.log('Selected Time2: ', value);
      // console.log('Formatted Selected Time2: ', dateString);
      this.createStartTime = dateString[0]
      this.createEndTime = dateString[1]
    },
    onChange2(value, dateString) {
      // console.log('Selected Time2: ', value);
      // console.log('Formatted Selected Time2: ', dateString);
      this.updateStartTime = dateString[0]
      this.updateEndTime = dateString[1]
    },
    onChange3(value, dateString) {
      // console.log('Selected Time2: ', value);
      // console.log('Formatted Selected Time2: ', dateString);
      this.deleteStartTime = dateString[0]
      this.deleteEndTime = dateString[1]
    },
    // tab也
    changeTabs(e) {
      this.queryKong()
      this.status = (this.$store.getters.userType == '22'&&this.$store.getters.enterpriseId=='72620e120c3a11ef8a26fa163ec52c23')?(e*1+2)*1:(e*1 - 1)*1
      this.dataListReq(this.status)
    },
    // 清空
    queryKong() {
      ;(this.orderNo = ''),
        (this.updateBy = ''), //处理人
        (this.updateTime = null), //处理时间
        (this.deleteBy = ''), //移除人
        (this.deleteTime = null), //移除时间
        (this.deleteReason = ''), //移除原因
        (this.enterpriseName = '')
      this.customerName = ''
      this.customerMobile = ''
      this.form3.setFieldsValue({ provinceId: undefined, cityId: undefined, areaId: undefined })
      // console.log(this.form3.getFieldValue('provinceId'))
      // this.provinceId=undefined
      // this.cityId=undefined
      // this.areaId=undefined
      this.detailedAddress = ''
      this.installType = undefined
      this.orderType = undefined
      this.createTime = undefined
      this.time = null
      ;(this.createStartTime = null),
        (this.createEndTime = null),
        (this.updateStartTime = null),
        (this.updateEndTime = null), //处理结束时间
        (this.deleteStartTime = null),
        (this.deleteEndTime = null)
    },
    // 下拉
    installChange(e) {
      this.installType = e
      this.List = []
      this.orderType = undefined
      this.$axios({
        method: 'get',
        url: '/api/basicdata/orderType/getList/' + e,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          this.List = res.data.rows
          console.log(res.data.rows)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 省市区
    changeProvince(e) {
      this.cityMap = []
      this.areaArr = []
      this.form3.setFieldsValue({ cityId: undefined, areaId: undefined })
      this.detailedAddress = ''
      // 市
      this.province = { provinceCode: e }
      this.provinceId = e
      this.$axios({
        method: 'post',
        url: '/api/basicdata/city/selectCityName',
        data: this.province
      }).then(res => {
        console.log(res.data.rows)
        this.cityMap = res.data.rows
      })
    },
    changeCity(e) {
      this.areaArr = []
      this.form3.setFieldsValue({ areaId: undefined })
      this.detailedAddress = ''
      // 区
      this.city = { cityCode: e }
      this.cityId = e
      this.$axios({
        method: 'post',
        url: '/api/basicdata/area/selectAreaName',
        data: this.city
      }).then(res => {
        console.log(res.data.rows)
        this.areaArr = res.data.rows
      })
    },
    changeArea(e) {
      this.areaCode = e
      this.areaId = e
      this.detailedAddress = ''
    },
    // 订单类型
    orderTypeChange(e) {
      console.log(e)
      this.orderType = e
    },
    // 编辑
    handleEditInfo(row) {
      this.visibleEdit = true
      this.infoEdit=Object.assign(row)
      this.$nextTick(() => {
        selectInstallType({enterpriseId:this.enterpriseId}).then(res=>{
          this.installTypeList=res.rows
        })
        this.formEdit.setFieldsValue(pick(Object.assign(row),'id','infoList','customerName','customerMobile','provinceId','cityId','areaId','detailedAddress','originalOrderNo','number','installType','orderType','model','serialNumber','purchaseOfStore','clientRequire'))
        this.formEdit.setFieldsValue({ provinceId: row.provinceId + ''})
        this.formEdit.setFieldsValue({cityId:row.cityId+''})
        this.formEdit.setFieldsValue({areaId:row.areaId+''})
        this.formEdit.setFieldsValue({installType:row.installTypeId})
        this.formEdit.setFieldsValue({orderType:row.orderTypeId})
        this.changeProvince(row.provinceId)
        this.changeCity(row.cityId)
        this.changeArea(row.areaId)
        this.installChangeEd(row.installTypeId)
        

      })
    },
    handleSubmitEdit(){
      this.formEdit.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.confirmLoading = true

          editCustomerOrder({...values,id:this.infoEdit.id,infoList:this.infoEdit.infoList}).then(res => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.$emit('ok')
              this.visibleEdit = false
              this.dataListReq(this.status)
            } else {
              this.$message.success(res.msg)
            }
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    // 查询
    queryList() {
      this.dataListReq(this.status)
    },
    dataListReq(status) {
      console.log(this.$store.getters.userType,this.$store.getters.enterpriseId,status);
      if (status == 0||status == 3) {
        this.$axios({
          method: 'get',
          url: '/api/order/customer/selectOrderList',
          params: {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            enterpriseName: this.enterpriseName,
            customerName: this.customerName,
            customerMobile: this.customerMobile,
            provinceId: this.form3.getFieldValue('provinceId'),
            cityId: this.form3.getFieldValue('cityId'),
            areaId: this.form3.getFieldValue('areaId'),
            detailedAddress: this.detailedAddress,
            installType: this.installType,
            orderType: this.orderType,
            createStartTime: this.createStartTime,
            createEndTime: this.createEndTime,
            status: status
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res.data)
          this.data12 = res.data.rows
          this.total = res.data.total
          this.datalist12 = res.data.rows.length
          console.log(this.datalist12)
        })
      } else if (status == 1||status == 4) {
        this.$axios({
          method: 'get',
          url: '/api/order/customer/selectOrderList',
          params: {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            orderNo: this.orderNo,
            updateBy: this.updateBy,
            createStartTime: this.createStartTime,
            createEndTime: this.createEndTime,
            updateStartTime: this.updateStartTime,
            updateEndTime: this.updateEndTime,
            enterpriseName: this.enterpriseName,
            customerName: this.customerName,
            customerMobile: this.customerMobile,
            provinceId: this.form3.getFieldValue('provinceId'),
            cityId: this.form3.getFieldValue('cityId'),
            areaId: this.form3.getFieldValue('areaId'),
            detailedAddress: this.detailedAddress,
            installType: this.installType,
            orderType: this.orderType,
            status: status
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res.data)
          this.data13 = res.data.rows
          this.total = res.data.total
        })
      } else if (status == 2||status == 5) {
        this.$axios({
          method: 'get',
          url: '/api/order/customer/selectOrderList',
          params: {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            updateBy: this.updateBy,
            createStartTime: this.createStartTime,
            createEndTime: this.createEndTime,
            updateStartTime: this.updateStartTime,
            updateEndTime: this.updateEndTime,
            deleteStartTime: this.deleteStartTime,
            deleteEndTime: this.deleteEndTime,
            deleteBy: this.deleteBy,
            deleteReason: this.deleteReason,
            enterpriseName: this.enterpriseName,
            customerName: this.customerName,
            customerMobile: this.customerMobile,
            provinceId: this.form3.getFieldValue('provinceId'),
            cityId: this.form3.getFieldValue('cityId'),
            areaId: this.form3.getFieldValue('areaId'),
            detailedAddress: this.detailedAddress,
            installType: this.installType,
            orderType: this.orderType,
            status: status
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res.data)
          this.data14 = res.data.rows
          this.total = res.data.total
        })
      }
    },
    // 多选
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    //导出
    xiadanExcept() {
      this.$axios({
        method: 'get',
        url: '/api/order/customer/export',
        params: {
          enterpriseName: this.enterpriseName,
          customerName: this.customerName,
          customerMobile: this.customerMobile,
          provinceId: this.provinceId,
          cityId: this.cityId,
          areaId: this.areaId,
          detailedAddress: this.detailedAddress,
          installType: this.installType,
          orderType: this.orderType,
          createTime: this.createTime,
          status: this.status
        },
        responseType: 'arraybuffer',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }).then(res => {
        console.log(res)
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
        })
        const a = document.createElement('a')
        // 生成文件路径
        let href = window.URL.createObjectURL(blob)
        a.href = href
        let fileName = '客户下单'
        // 文件名中有中文 则对文件名进行转码
        a.download = decodeURIComponent(fileName)
        // 利用a标签做下载
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(href)
      })
    },
    // 批量下单
    handleEdit18() {
      console.log(this.data12)
      var array = []
      for (var i = 0; i < this.selectedRowKeys.length; i++) {
        array[i] = this.data12[this.selectedRowKeys[i]].id
      }
      console.log(array)
      if (array.length != 0) {
        this.$axios({
          method: 'post',
          url: '/api/order/customer/sendOrder',
          data: array,
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          console.log(res)
          if (res.data.code == 0) {
            this.$message.success('下单成功')
            // 获取客户下单数量
            this.$store.dispatch('getXiadan')
            this.dataListReq(this.status)
            this.selectedRowKeys = []
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('请选择订单')
      }
    },
    // 下单
    handleEdit12(record) {
      this.loading2 = true
      this.$axios({
        method: 'post',
        url: '/api/order/customer/sendOrder',
        data: [record.id],
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          this.$message.success('下单成功')
          // 获取客户下单数量
          this.$store.dispatch('getXiadan')
          this.dataListReq(this.status)
          this.loading2 = false
        } else {
          this.$message.error(res.data.msg)
          this.loading2 = false
        }
      })
    },
    // 移除
    handleRemove12(record) {
      this.visible13 = true
      this.handleRemoveRecord = record.id
    },
    // 恢复
    handleAdd14(record) {
      console.log(record)
      this.$axios({
        method: 'get',
        url: '/api/order/customer/recoverOrder?id=' + record.id,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        console.log(res.data)
        if (res.data.code == 0) {
          this.$message.success('恢复成功')
          // 获取客户下单数量
          this.$store.dispatch('getXiadan')
          this.dataListReq(this.status)
        }
      })
    },
    handleSubmit12() {
      this.visible12 = false
    },
    removeState(e) {
      console.log(e)
      this.removeStateNum = e
    },
    remarkChange(e) {
      // console.log(e)
      // this.remarkChanges=e.data
    },
    handleSubmit13() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          console.log('Received values of form: ', values)
          this.$axios({
            method: 'post',
            url: '/api/order/customer/removeOrder',
            data: {
              id: this.handleRemoveRecord,
              deleteReason: values.status,
              remark: values.remark ? values.remark : this.remarkChanges
            },
            headers: {
              token: Vue.ls.get(ACCESS_TOKEN),
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
            console.log(res)
            if (res.data.code == 0) {
              this.$message.success('移除成功')
              // 获取客户下单数量
              this.$store.dispatch('getXiadan')
              this.visible13 = false
              this.confirmLoading = false
              this.dataListReq(this.status)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
